import React from "react";
import styles from "./style.m.css";
import Icon from "../../atoms/icon";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

const MyVikatanHeader = props => {
  let menuItems = get(props, ["menu", "items"], []);
  console.log("menuItems---->", menuItems);

  return (
    <div className={styles["header-outer"]}>
      <div className={`${styles["header-section"]} container`}>
        {/* Top header */}
        <div className={styles["top-header"]}>
          <div className={styles["myvikatan-logo"]}>
            <a href="/myvikatan" className={styles["link"]}>
              <Icon type="my-vikatan-logo" className={styles["myvikatan-icon"]} />
            </a>
          </div>
        </div>
      </div>

      {/* Menu */}
      {props.showMenu && (
        <nav className={styles["menu-nav"]}>
          <a href="/myvikatan" className={styles["link"]}>
            <Icon type="home" className={styles["home-icon"]} />
            {/* <span className={styles["myvikatan-text"]}>#MyVikatan</span> */}
          </a>
          <div className={styles["menu-nav-list-wrap"]}>
            {menuItems &&
              menuItems.length > 0 &&
              menuItems.map(item => {
                const slug = item.url || item.path;
                return (
                  <a
                    key={item.id}
                    href={slug}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={`${styles["menu-item"]} `}
                  >
                    {item.title}
                  </a>
                );
              })}
          </div>
        </nav>
      )}
      {props.showBanner && (
        <div>
          <div className="hidden-mobile">
            <img
              src="https://media.vikatan.com/vikatan/2025-08-13/k53f6mi7/MyVikatanbanner1140x90Opt1a-1.png?format=webp&dpr=1.0&w=1140"
              alt=""
            />
          </div>
          <div className="hidden-desktop">
            <img
              src="https://media.assettype.com/vikatan/2025-08-13/as2nsvjc/MyVikatanbannerarticlemobiletopbanner375x120Opt1a-1.png?format=webp&w=400&dpr=1.0"
              alt=""
            />
          </div>
        </div>
      )}
    </div>
  );
};

MyVikatanHeader.propTypes = {
  showMenu: PropTypes.Boolean,
  showBanner: PropTypes.Boolean
};

function mapStateToProps(state) {
  return { menu: get(state, ["qt", "data", "header", "MyvikatanHeaderMenu"]) };
}

export default connect(mapStateToProps)(MyVikatanHeader);
